import { buildCommunityPostCommentPath } from '@arthelper/shared/community-path';

export type ModerationContentLink = {
  scanType: string;
  result?: Record<string, unknown> | null;
  community?: { slug: string } | null;
  communityPost?: { slug: string } | null;
  communityComment?: { id: string; post?: { slug: string } | null } | null;
};

export function getModerationFlagReason(item: ModerationContentLink): string {
  if (item.result && typeof item.result === 'object' && 'reason' in item.result) {
    return String(item.result.reason);
  }
  if (item.scanType === 'nsfw') return 'nsfw';
  if (item.scanType === 'ai_detection') return 'ai_detection';
  return item.scanType;
}

export function getModerationContentUrl(item: ModerationContentLink): string | null {
  if (item.scanType === 'comment_spam') return null;
  const communitySlug = item.community?.slug;
  if (item.communityPost?.slug && communitySlug) {
    return `${__TOWN_SQUARE_URL__}/community/${communitySlug}/post/${item.communityPost.slug}`;
  }
  if (item.communityComment?.post?.slug && communitySlug) {
    return `${__TOWN_SQUARE_URL__}${buildCommunityPostCommentPath(
      communitySlug,
      item.communityComment.post.slug,
      item.communityComment.id
    )}`;
  }
  return null;
}
